<template>
  <div class="report-engagement-rate-percent h-24">
    <div class="report-engagement-rate-percent__progress">
      <aha-progress-circle
        :key="keyCounter"
        :percent="100"
        :radius="30"
        :ring-width="12"
        :progress-bar-color="loadingStages[0].progressBarColor"
        :box-shadow="loadingStages[0].boxShadow"
        :inner-box-shadow="loadingStages[0].innerBoxShadow"
        :animation-duration="animationDuration / 1000"
      />
    </div>
    <div class="report-engagement-rate-percent__text">
      <h4 class="font-bold mb-1 text-base leading-tight">
        {{ $i18nPresenter.t(loadingStages[0].title) }}
      </h4>
      <p class="text-md14-h18 text-base-90">
        {{ $i18nPresenter.t(loadingStages[0].subTitle) }}
      </p>
    </div>
  </div>
</template>

<script>

const loadingStages = [
  // {
  //   progressBarColor: '#348EF6',
  //   boxShadow: '2px 4px 6px rgba(52, 142, 246, 0.11)',
  //   innerBoxShadow: 'inset 1px 1px 6px rgba(52, 142, 246, 0.11)',
  //   title: 'Doing the maths...',
  //   subTitle: '- Your friends at AhaSlides',
  // },
  // {
  //   progressBarColor: '#348EF6',
  //   boxShadow: '2px 4px 6px rgba(52, 142, 246, 0.11)',
  //   innerBoxShadow: 'inset 1px 1px 6px rgba(52, 142, 246, 0.11)',
  //   title: 'Scrambling the egg...',
  //   subTitle: 'Your report will be available shortly.',
  // },
  // {
  //   progressBarColor: '#348EF6',
  //   boxShadow: '2px 4px 6px rgba(52, 142, 246, 0.11)',
  //   innerBoxShadow: 'inset 1px 1px 6px rgba(52, 142, 246, 0.11)',
  //   title: 'Bringing you the Joy of Engagement...',
  //   subTitle: '- Your friends at AhaSlides',
  // },
  {
    progressBarColor: '#348EF6',
    boxShadow: '2px 4px 6px rgba(52, 142, 246, 0.11)',
    innerBoxShadow: 'inset 1px 1px 6px rgba(52, 142, 246, 0.11)',
    title: 'Generating report',
    subTitle: '- Just a moment please...',
  },
]
export default {
  name: 'ReportEngagementRateSkeleton',
  data() {
    return {
      loadingStages,
      animationDuration: 2000,
      interval: null,
      keyCounter: 0,
    }
  },
  mounted() {
    this.interval = window.setInterval(() => {
      // creating a dynamic css keyframe animation is tricky
      // so use setInterval to make the pie chart's animation loops
      this.keyCounter++
    }, this.animationDuration)
  },

  destroyed() {
    window.clearInterval(this.interval)
  },
}
</script>

<style lang="scss" scoped>
.report-engagement-rate-percent {
  @apply flex flex-row items-center p-2;
}
.report-engagement-rate-percent__progress {
  @apply mr-3 relative;
}
.report-engagement-rate-percent__number {
  @apply absolute top-0 left-0;
  @apply w-full h-full flex items-center justify-center;
  @apply font-bold;
}
</style>
